import { Component, OnInit } from '@angular/core';
import {
  LazyLoadedComponentDefinition
} from '../../../app-common/components/lazy-loaded-component/lazy-loaded-component.definition';

@Component({
  selector: 'app-snippet-popup',
  templateUrl: './snippet-popup.component.html',
  styleUrls: ['./snippet-popup.component.scss']
})
export class SnippetPopupComponent implements OnInit {

  definition: LazyLoadedComponentDefinition = {
    instance: this,
    module: () => import('../../snippet.module').then(m => m.SnippetModule) as any,
    component: () => import('../snippet-popup-internal/snippet-popup-internal.component').then(m => m.SnippetPopupInternalComponent),
    inputs: {},
    outputs: {}
  };
  constructor() { }

  ngOnInit(): void {
  }

}
